(function () {
  function start(root) {
    if (root.dataset.ready) return;
    const dataNode = root.querySelector('[data-cfl-data]');
    if (!dataNode || !globalThis.CFFlavorCore) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch { return; }
    root.dataset.ready = 'true';
    const C = globalThis.CFFlavorCore;
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const m = data.messages;
    const familyMap = new Map(data.families.map(f => [f.id, f]));
    const ingredientMap = new Map(data.ingredients.map(i => [i.id, i]));
    const pairMap = new Map(data.pairings.map(p => [p.id, p]));
    const baseMap = new Map(data.bases.map(b => [b.id, b]));
    let state = C.parseHash(location.hash, data);
    let limit = 9, currentPair = null, currentBase = 'all', lastTrigger = null, toastTimer, searchTimer;
    let favorites = [];
    try { const stored = JSON.parse(localStorage.getItem('cf-flavor-favorites-v1') || '[]'); if (Array.isArray(stored)) favorites = [...new Set(stored.filter(id => typeof id === 'string' && pairMap.has(id)))]; } catch {}
    const dialog = $('.cfl-dialog');
    const results = $('#cfl-results');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const escape = text => String(text).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const message = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll('{'+k+'}', String(v)), m[key] || key);
    const image = family => '<img src="'+escape(data.images[family])+'" width="900" height="900" loading="lazy" alt="'+escape(data.imageAlts[family])+'">';
    const tags = pair => pair.families.map(f => '<span>'+escape(familyMap.get(f).name)+'</span>').join('');
    function toast(text) { clearTimeout(toastTimer); const notice = $('.cfl-toast'); (dialog.open ? dialog : root).append(notice); notice.textContent = text; notice.hidden = false; toastTimer = setTimeout(() => {notice.hidden = true;}, 4500); }
    function syncUrl(pair = currentPair, base = currentBase) {
      const hash = C.serialize(state, pair, pair ? base : state.base);
      const url = new URL(location.href); url.hash = hash;
      try { history.replaceState(null, '', url); } catch {}
    }
    function syncControls() {
      $('#cfl-search').value = state.search;
      $('#cfl-base').value = state.base;
      $('[data-saved-only]').checked = state.savedOnly;
      $$('[data-family]').forEach(button => {
        const selected = state.families.includes(button.dataset.family);
        button.setAttribute('aria-pressed', String(selected));
        button.classList.toggle('is-selected', selected);
      });
      $('[data-all]').setAttribute('aria-pressed', String(!state.families.length));
      const family = state.families.at(-1) || 'citrus';
      const hero = $('.cfl-wheel-photo img');
      if (hero.getAttribute('src') !== data.images[family]) { hero.src = data.images[family]; hero.alt = data.imageAlts[family]; }
      root.style.setProperty('--cfl-active', familyMap.get(family).color);
    }
    function card(pair) {
      const saved = favorites.includes(pair.id);
      return '<article class="cfl-card"><div class="cfl-card-image">'+image(pair.imageFamily)+'<button type="button" class="cfl-save-icon" data-save="'+pair.id+'" aria-label="'+escape(saved ? m.remove : m.save)+'" aria-pressed="'+saved+'">'+(saved ? '✓' : '+')+'</button></div><div class="cfl-card-copy"><div class="cfl-tags">'+tags(pair)+'</div><h3>'+escape(pair.title)+'</h3><p>'+escape(pair.note)+'</p><p class="cfl-card-bases">'+pair.bases.map(b => escape(baseMap.get(b).name)).join(' · ')+'</p><button type="button" class="cfl-text-link" data-open-pair="'+pair.id+'">'+escape(m.view_pair)+' <span aria-hidden="true">↗</span></button></div></article>';
    }
    function render(updateUrl = true) {
      syncControls();
      const found = C.filter(data, state, favorites);
      results.innerHTML = found.slice(0, limit).map(card).join('');
      const countLabel = message('match_count', {count:found.length});
      $('[data-count]').textContent = countLabel;
      const wheelResults = $('[data-wheel-results]');
      if (wheelResults) { wheelResults.textContent = countLabel; wheelResults.hidden = false; }
      $('[data-showing]').textContent = message('showing', {shown:Math.min(limit, found.length),count:found.length});
      $('.cfl-empty').hidden = Boolean(found.length);
      $('[data-empty-text]').textContent = state.savedOnly && favorites.length === 0 ? m.no_saved : m.no_results_text;
      $('[data-load-more]').hidden = limit >= found.length;
      if (updateUrl) syncUrl();
    }
    function changeFamily(id) {
      const pos = state.families.indexOf(id);
      if (pos > -1) state.families.splice(pos, 1);
      else if (state.families.length < 2) state.families.push(id);
      else { toast(m.max_families); return; }
      limit = 9; render();
    }
    function save(id) {
      const next = favorites.includes(id) ? favorites.filter(x => x !== id) : [...favorites, id];
      try { localStorage.setItem('cf-flavor-favorites-v1', JSON.stringify(next)); }
      catch { toast(m.storage_unavailable); return; }
      favorites = next;
      toast(favorites.includes(id) ? m.saved_done : m.removed_done);
      const before = document.activeElement;
      render(false);
      if (currentPair) renderDialog(false);
      else { const replacement = results.querySelector('[data-save="'+id+'"]'); if (replacement) replacement.focus({preventScroll:true}); else if (before?.dataset.save) $('[data-saved-only]').focus(); }
    }
    function renderDialog(focusTitle = false) {
      const pair = pairMap.get(currentPair); if (!pair) return;
      const saved = favorites.includes(pair.id);
      const base = baseMap.get(currentBase);
      const notes = pair.ingredients.map(id => {const i=ingredientMap.get(id);return '<div><h4>'+escape(i.name)+'</h4><p>'+escape(i.description)+'</p></div>';}).join('');
      $('[data-dialog-content]').innerHTML = '<div class="cfl-dialog-photo">'+image(pair.imageFamily)+'</div><div class="cfl-dialog-copy"><p class="cfl-eyebrow">'+escape(m.pair_label)+'</p><h2 id="cfl-dialog-title" tabindex="-1">'+escape(pair.title)+'</h2><div class="cfl-tags">'+tags(pair)+'</div><h3>'+escape(m.why)+'</h3><p>'+escape(pair.note)+'</p><label for="cfl-dialog-base">'+escape(m.pair_base)+'</label><select id="cfl-dialog-base">'+pair.bases.map(id=>'<option value="'+id+'"'+(id===currentBase?' selected':'')+'>'+escape(baseMap.get(id).name)+'</option>').join('')+'</select><p class="cfl-base-note">'+escape(base?.note || '')+'</p><h3>'+escape(m.uses)+'</h3><p>'+escape(pair.uses)+'</p><details class="cfl-dialog-notes"><summary>'+escape(m.ingredient_notes)+' <span aria-hidden="true">+</span></summary>'+notes+'</details><p class="cfl-note">'+escape(m.inspiration)+'</p><div class="cfl-dialog-actions"><button type="button" class="cfl-button" data-save="'+pair.id+'" aria-pressed="'+saved+'">'+escape(saved?m.saved:m.save)+'</button><button type="button" class="cfl-button cfl-button-outline" data-share>'+escape(m.share)+'</button><button type="button" class="cfl-text-link" data-print>'+escape(m.print)+'</button></div><div class="cfl-share-fallback" hidden><label for="cfl-share-url">'+escape(m.share_fallback)+'</label><input readonly id="cfl-share-url" aria-label="'+escape(m.share_label)+'"></div><div class="cfl-dialog-links"><a href="/pages/how-to-use-your-cannafuse-pouch-for-cbd-oil-infusion">'+escape(m.guide)+' ↗</a><a href="/blogs/recipe">'+escape(m.recipes)+' ↗</a></div></div>';
      if (focusTitle) $('#cfl-dialog-title').focus({preventScroll:true});
      else if (dialog.open) $('[data-dialog-content] [data-save]').focus({preventScroll:true});
    }
    function openPair(id, trigger = null, updateUrl = true) {
      const pair = pairMap.get(id); if (!pair) return;
      lastTrigger = trigger || document.activeElement;
      currentPair = id;
      currentBase = pair.bases.includes(state.base) ? state.base : pair.bases[0];
      renderDialog();
      if (!dialog.open) dialog.showModal();
      dialog.scrollTop = 0;
      document.body.classList.add('cfl-dialog-open');
      $('#cfl-dialog-title').focus({preventScroll:true});
      if (updateUrl) syncUrl();
    }
    function closePair() { if (dialog.open) dialog.close(); }
    dialog.addEventListener('close', () => {
      currentPair = null; document.body.classList.remove('cfl-dialog-open'); syncUrl();
      if (lastTrigger?.isConnected) lastTrigger.focus({preventScroll:true});
      else $('#cfl-search').focus({preventScroll:true});
    });
    dialog.addEventListener('click', event => { if (event.target === dialog) {const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closePair();} });
    root.addEventListener('click', async event => {
      const element = event.target.closest('button,a'); if (!element) return;
      if (element.dataset.family) {event.preventDefault();changeFamily(element.dataset.family);}
      if (element.hasAttribute('data-all')) {state.families=[];limit=9;render();}
      if (element.hasAttribute('data-clear')) {clearTimeout(searchTimer);state={families:[],base:'all',search:'',savedOnly:false};limit=9;render();}
      if (element.hasAttribute('data-load-more')) {limit+=9;render(false);}
      if (element.dataset.exploreFamily) {
        event.preventDefault();state.families=[element.dataset.exploreFamily];state.search='';state.savedOnly=false;limit=9;render();
        $('#cf-explore').scrollIntoView({behavior:motion.matches?'auto':'smooth',block:'start'});
      }
      if (element.tagName === 'A' && !element.dataset.family && !element.dataset.exploreFamily && !element.dataset.openPair) {
        const href = element.getAttribute('href') || '';
        if (/^#(?:cf-|ingredient-)[a-z0-9-]+$/i.test(href)) {
          const target = $(href);
          if (target) { event.preventDefault(); target.scrollIntoView({behavior:motion.matches?'auto':'smooth',block:'start'}); }
        }
      }
      if (element.dataset.openPair) {event.preventDefault();openPair(element.dataset.openPair,element);}
      if (element.dataset.save) {event.preventDefault();save(element.dataset.save);}
      if (element.hasAttribute('data-close')) closePair();
      if (element.hasAttribute('data-surprise')) {
        const found=C.filter(data,state,favorites);
        if (found.length) openPair(found[Math.floor(Math.random()*found.length)].id,element);
        else toast(m.no_results_text);
      }
      if (element.hasAttribute('data-share')) {
        const url=new URL(location.href);
        if (root.dataset.themeRole && root.dataset.themeRole !== 'main' && /^\d+$/.test(root.dataset.themeId || '')) url.searchParams.set('preview_theme_id',root.dataset.themeId);
        url.hash=C.serialize({families:[],base:currentBase,search:''},currentPair,currentBase);
        try {if(!navigator.clipboard?.writeText)throw new Error('clipboard');await navigator.clipboard.writeText(url.href);toast(m.share_done);}
        catch {$('.cfl-share-fallback').hidden=false;$('#cfl-share-url').value=url.href;$('#cfl-share-url').focus();$('#cfl-share-url').select();}
      }
      if (element.hasAttribute('data-print')) window.print();
      if (element.hasAttribute('data-motion')) {
        const paused = root.classList.toggle('cfl-paused');
        element.setAttribute('aria-pressed',String(paused));element.textContent=paused?m.resume_motion:m.motion;
      }
    });
    root.addEventListener('change',event=>{
      if(event.target.id==='cfl-base'){state.base=event.target.value;limit=9;render();}
      if(event.target.hasAttribute('data-saved-only')){state.savedOnly=event.target.checked;limit=9;render();}
      if(event.target.id==='cfl-dialog-base'){currentBase=event.target.value;$('.cfl-base-note').textContent=baseMap.get(currentBase).note;syncUrl();}
    });
    $('#cfl-search').addEventListener('input',event=>{state.search=event.target.value.slice(0,120);clearTimeout(searchTimer);searchTimer=setTimeout(()=>{limit=9;render();},100);});
    $('#cfl-ingredient-search').addEventListener('input',event=>{
      const q=C.normalize(event.target.value);let count=0;
      $$('[data-ingredient]').forEach(el=>{const i=ingredientMap.get(el.dataset.ingredient);const visible=C.normalize(i.name+' '+i.notes+' '+i.families.map(f=>familyMap.get(f).name).join(' ')).includes(q);el.hidden=!visible;if(visible)count++;});
      $('[data-ingredient-count]').textContent=message('ingredient_count',{count});$('[data-ingredient-empty]').hidden=Boolean(count);
    });
    function followHash() {
      if (!/pair=|families=|base=|q=/.test(location.hash)) return;
      state=C.parseHash(location.hash,data);limit=9;render(false);
      if(state.pair)openPair(state.pair,null,false);
    }
    window.addEventListener('hashchange',followHash);
    $$('[data-family]').filter(el=>el.tagName==='A').forEach(el=>{el.setAttribute('role','button');el.addEventListener('keydown',event=>{if(event.key===' '){event.preventDefault();el.click();}});});
    $('.cfl-controls').hidden=false;$('.cfl-directory-controls').hidden=false;$('[data-motion]').hidden=false;
    $('[data-ingredient-count]').textContent=message('ingredient_count',{count:data.ingredients.length});
    if(motion.matches){root.classList.add('cfl-paused');$('[data-motion]').textContent=m.resume_motion;$('[data-motion]').setAttribute('aria-pressed','true');}
    render(false);
    if(state.pair)openPair(state.pair,null,false);
  }
  document.querySelectorAll('[data-cfl]').forEach(start);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-cfl]').forEach(start));
})();
